<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.changeType')">
              <j-dict-select-tag :placeholder="$t('label.pleaseSelectChangeType')"  v-model="queryParam.changeScope" dictCode="change_type"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.materialNumber')">
              <j-input  :placeholder="$t('label.pleaseEnterTheMaterialNo')" v-model="queryParam.mmCode"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.status')">
              <j-dict-select-tag :placeholder="$t('label.pleaseSelectStatus')"  v-model="queryParam.approvalStatus" dictCode="shzt"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>
<!--      <a-button type="primary" icon="download" @click="handleExportXls('结算价格变更')">{{$t('button.export')}}</a-button>-->
<!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">-->
<!--        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>-->
<!--      </a-upload>-->
     <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{$t('tip.selected')}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{$t('tip.term')}}
        <a style="margin-left: 24px" @click="onClearSelected">{{$t('button.clear')}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template v-for="(item, index) in columns" :slot="item.slotName">
          <span :key="index">{{ $t(item.slotName) }}</span>
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>
<!--        <template slot="imgSlot" slot-scope="text">-->
<!--          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>-->
<!--          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>-->
<!--        </template>-->
<!--        <template slot="fileSlot" slot-scope="text">-->
<!--          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>-->
<!--          <a-button-->
<!--            v-else-->
<!--            :ghost="true"-->
<!--            type="primary"-->
<!--            icon="download"-->
<!--            size="small"-->
<!--            @click="downloadFile(text)">-->
<!--            下载-->
<!--          </a-button>-->
<!--        </template>-->

        <span slot="action" slot-scope="text, record">
         <!-- <a @click="handleEdit(record)">{{$t('button.edit')}}</a>

          <a-divider type="vertical" />-->
          <a-dropdown>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{$t('button.details')}}</a>
              </a-menu-item>
             <!-- <a-menu-item>
                <a-popconfirm :title="$t('tip.confirmDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{$t('button.delete')}}</a>
                </a-popconfirm>
              </a-menu-item>-->
              <a-menu-item v-has="'approvalContract'" v-if="record.approvalStatus=='00'">
                <a-popconfirm :title="$t('tip.makeSureTheReviewIsApproved')" @confirm="() => handlePass(record.id)">
                  <a>{{$t('button.reviewApproved')}}</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-has="'approvalContract'" v-if="record.approvalStatus=='00'">
                  <a-popconfirm :title="$t('tip.rejected')" @confirm="() => handleFailure(record.id)">
                 <a>{{$t('button.rejected')}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-md-contract-price-change-modal ref="modalForm" @ok="modalFormOk"></efs-md-contract-price-change-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsMdContractPriceChangeModal from './modules/EfsMdContractPriceChangeModal'
  import { putAction } from '@api/manage'

  export default {
    name: 'EfsMdContractPriceChangeList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EfsMdContractPriceChangeModal
    },
    data () {
      return {
        description: '结算价格变更管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
            {
                title:'变更类型',
                align:"center",
                dataIndex: 'changeScope_dictText'
            },
            {
                slotName: 'tableHeader.materialNumber',
                        scopedSlots: { title: 'tableHeader.materialNumber'},
                align:"center",
                dataIndex: 'mmCode'
            },
          {
            slotName: 'tableHeader.materialName',
            scopedSlots: { title: 'tableHeader.materialName'},
            align:"center",
            dataIndex: 'mmName'
          },
          {
             slotName: 'tableHeader.unitPrice',
            scopedSlots: { title: 'tableHeader.unitPrice'},
            align:"center",
            dataIndex: 'unitPrice'
          },
          {
            slotName: 'tableHeader.effectiveTime',
            scopedSlots: { title: 'tableHeader.effectiveTime'},
            align:"center",
            dataIndex: 'startTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },

          {
            slotName: 'tableHeader.reviewStatus',
            scopedSlots: { title: 'tableHeader.reviewStatus'},
            align:"center",
            dataIndex: 'approvalStatus_dictText'
          },
            {
                slotName: 'tableHeader.createdBy',
            scopedSlots: { title: 'tableHeader.createdBy'},
                align:"center",
                dataIndex: 'createBy_dictText'
            },
          {
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
          }
        ],
        url: {
          list: "/priceChange/efsMdContractPriceChange/list",
          delete: "/priceChange/efsMdContractPriceChange/delete",
          deleteBatch: "/priceChange/efsMdContractPriceChange/deleteBatch",
          exportXlsUrl: "/priceChange/efsMdContractPriceChange/exportXls",
          importExcelUrl: "priceChange/efsMdContractPriceChange/importExcel",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
        handlePass(id){
            putAction('/priceChange/efsMdContractPriceChange/updateApprovalStatus', {"id": id, "approvalStatus": "30"}).then((res) => {
                if (res.success) {
                    this.$message.success(res.message);
                    this.loadData();
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        handleFailure(id){
            putAction('/priceChange/efsMdContractPriceChange/updateApprovalStatus', {"id": id, "approvalStatus": "40"}).then((res) => {
                if (res.success) {
                    this.$message.success(res.message);
                    this.loadData();
                } else {
                    this.$message.error(res.message);
                }
            })
        },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>